<template>
	<div>
		<v-list two-line class="performance-review-settings-container flexible-height">
			<v-list-tile @click="navToDefaultTemplate">
				<v-list-tile-content>
					<v-list-tile-title>Default Template</v-list-tile-title>
					<v-list-tile-sub-title>Add default discussion points to all performance reviews that use this template.</v-list-tile-sub-title>
				</v-list-tile-content>
			</v-list-tile>

			<v-divider inset></v-divider>

            <v-list-tile @click="navToCustomTemplates">
				<v-list-tile-content>
					<v-list-tile-title>Custom Templates</v-list-tile-title>
					<v-list-tile-sub-title>Create custom templates from scratch. These are not linked to the {{ $term('employee', { possessive: true }) }} {{ $term('positionDescription') }}</v-list-tile-sub-title>
				</v-list-tile-content>
			</v-list-tile>
		</v-list>
	</div>
</template>

<script>
	export default {
		created() {
			this.$store.dispatch('setPageTitle', 'Configure Performance Reviews');
		},
		methods: {
			navToDefaultTemplate() {
				this.$router.push({ name: 'defaultDiscussionPoints' });
			},
			navToCustomTemplates() {
				this.$router.push({ name: 'prTemplates' });
			}
		}
	};
</script>

<style scoped>
	.performance-review-settings-container >>> .v-divider--inset:not(.v-divider--vertical) {
		margin-left: 20px;
		margin-right: 20px;
		max-width: 100%;
	}
</style>
